import { isAdminFromToken } from "../../utils/authToken";
import { DP_PAGE } from "../dp/routes";
import { OPERACOES_PAGE } from "../operacoes/routes";

/**
 * Hub de onde as telas da NR1 (e os formulários NR1) são abertas. O DP gerencia
 * a NR1 desde 05/11/2026, mas não enxerga Operações: para ele, o pai é o DP.
 */
export function nr1HubFromToken(token: string | null): { label: string; to: string } {
  return isAdminFromToken(token)
    ? { label: "Operações", to: OPERACOES_PAGE() }
    : { label: "Departamento Pessoal", to: DP_PAGE() };
}
